import { createBrowserRouter, RouterProvider } from "react-router-dom";

import Header from "./components/header/Header";
import ForgotPassword from "./features/authentication/ForgotPassword";
import Login from "./features/authentication/Login";
import Register from "./features/authentication/Register";
import ResetPassword from "./features/authentication/ResetPassword";
import IISSDecisionFlow from "./features/questionnaire/IISSDecisionFlow";

const router = createBrowserRouter([
    {
        path: "/",
        element: <Login />,
    },
    {
        path: "/register",
        element: <Register />,
    },
    {
        path: "/reset-password",
        element: <ResetPassword />,
    },
    {
        path: "/forgot-password",
        element: <ForgotPassword />,
    },
    {
        path: "/questions",
        element: <IISSDecisionFlow />,
    },
]);

function App() {
    return (
        <div>
            <Header />
            <RouterProvider router={router} />
        </div>
    );
}

export default App;
